import { Link } from "react-router-dom";
import { Sparkles, Scan, Zap, Shield, ArrowRight, Download } from "lucide-react";

export default function LandingPage() {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <div className="absolute inset-0 jx-grid-bg opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-slate-950" />
      <div className="relative z-10 max-w-md mx-auto px-6 pt-14 pb-24">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-2xl jx-shutter flex items-center justify-center">
            <Sparkles size={18} className="text-slate-900" />
          </div>
          <span className="font-heading font-black text-xl tracking-tight">Jixxeo Scan</span>
        </div>

        <h1 className="mt-10 font-heading text-4xl sm:text-5xl font-black leading-tight">
          Point. <span className="text-cyan-300">Tap.</span><br/>Discover.
        </h1>
        <p className="mt-3 text-slate-300 text-base leading-relaxed">
          The world's easiest AI camera. Aim at anything, tap one button and Jixxeo AI explains it — plants, animals, food,
          signs, art, machines. Instant answers, zero friction.
        </p>

        <div className="mt-6 flex gap-3">
          <Link data-testid="landing-get-started" to="/auth" className="flex-1 h-12 rounded-2xl bg-cyan-400 text-slate-950 font-semibold flex items-center justify-center gap-2 active:scale-95">
            Get started <ArrowRight size={16} />
          </Link>
          <Link data-testid="landing-open-scanner" to="/scan" className="h-12 px-4 rounded-2xl border border-white/15 flex items-center justify-center gap-2 text-slate-200 active:scale-95">
            <Scan size={16} /> Try
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-3 gap-2">
          {[
            { Icon: Zap,    t: "One tap",   d: "Instant AI" },
            { Icon: Shield, t: "Private",   d: "Your scans" },
            { Icon: Download, t: "Installable", d: "PWA on any device" },
          ].map(({ Icon, t, d }) => (
            <div key={t} className="jx-glass rounded-2xl p-3">
              <Icon size={18} className="text-cyan-300" />
              <p className="mt-1 font-heading font-semibold text-sm">{t}</p>
              <p className="text-[11px] text-slate-400">{d}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 jx-glass rounded-3xl p-4">
          <p className="font-mono-data text-[11px] uppercase tracking-widest text-cyan-300">SEE IT. TAP IT. KNOW IT.</p>
          <p className="mt-1 text-sm text-slate-300">
            Every scan earns XP and unlocks badges. Install to your home screen for a one-tap launch.
          </p>
        </div>
      </div>
    </div>
  );
}
